"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.checkVoid = void 0;
const errors_1 = require("../../interpreter/errors");
const errors_2 = require("../errors");
const checkVoid = (command, expressionType, context) => {
    if (expressionType == 'void') {
        throw (0, errors_1.handleRuntimeError)(context, new errors_2.TypeError(command, 'char, int or float', 'void'));
    }
    return undefined;
};
exports.checkVoid = checkVoid;
//# sourceMappingURL=checkSingleVoid.js.map